import { List } from 'immutable';
import shuffle from "./shuffle";
export default function sample(list, n) {
  return shuffle(list).slice(0, Math.max(0, n));
}